import {Chat} from "../types/chat";
import ComponentConfig from "../config/componentConfig";
import AgentChat from "./agentChat";
import BotChat from "./botChat";
import {WidgetConfig} from "../types/config";
import AlpineComponent from "./response/alpineComponent";

export default class ChatMaker {


    constructor(
        private widgetConfig: WidgetConfig,
        private componentConfig: ComponentConfig,
        protected widgetDom: ShadowRoot,
        protected alpineComponent: AlpineComponent,
    ) {
    }

    async getChatToUse(): Promise<Chat> {
        if(this.componentConfig.agentChatId !== null || this.componentConfig.forceAgentChat) {
            let chat = this.getAgentChatConnection();
            if (chat !== null) {
                return chat;
            }
        }

        if(this.componentConfig.botChatId !== null) {
            return this.getBotChatConnection();
        }

        if (this.componentConfig.allowChatBot) {
            return this.getBotChatConnection();
        }

        if (this.componentConfig.allowAgentChat) {
            let chat = this.getAgentChatConnection();
            if (chat !== null) {
                return chat;
            }
        }

        return this.getBotChatConnection();
    }

    private getAgentChatConnection(): null|AgentChat {
        return new AgentChat(this.widgetConfig, this.componentConfig, this.alpineComponent);
    }

    private async getBotChatConnection(): Promise<BotChat>
    {
        return new BotChat(this.widgetConfig, this.componentConfig, this.alpineComponent);
    }
}